import _extends from 'babel-runtime/helpers/extends';

export default {
  data: function data() {
    return {
      formConfig: {
        labelWidth: '97px'
      }
    };
  },


  computed: {
    innerSubmitButton: function innerSubmitButton() {
      return _extends({
        type: 'primary',
        text: this.$t('playTurbo.creative.languagePacks.confirm')
      }, this.$attrs['submitButton'] || {});
    }
  },

  methods: {
    clearValidate: function clearValidate(cb) {
      return this.$refs.form.clearValidate(cb);
    },
    validate: function validate(cb) {
      return this.$refs.form.validate(cb);
    },
    resetFields: function resetFields() {
      return this.$refs.form.resetFields();
    }
  }
};